// no conflict
var $ = jQuery.noConflict();

$(document).ready(function () {
	let blackoutTimer;

	// =========================
	// BLACKOUT (FIXED)
	// =========================
	$(".blackout").on("mouseenter", function () {
		clearTimeout(blackoutTimer);

		blackoutTimer = setTimeout(() => {
			var els = document.querySelectorAll(".showSubMenu, .show-mega");

			els.forEach((el) => {
				el.classList.remove("showSubMenu", "show-mega");
			});

			$("header .chev_a a").removeClass("show-mega flip-arrow");
			$(".menu-responsive-wrap").removeClass("show active");
			$(".menu-responsive-wrap-search").removeClass("active");
			$(".blackout").removeClass("is-active");
			$("header").removeClass("dark-head");
		}, 300);
	});

	// Cancel close if user goes back to menu
	$(".chev_a, .mega_menu_toggle, .menu-responsive-wrap").on(
		"mouseenter",
		function () {
			clearTimeout(blackoutTimer);
		},
	);

	// =========================
	// MEGA MENU
	// =========================
	$(".mega_menu_toggle").click(function () {
		$(this).toggleClass("is-active");
		$(".mega-wrap").toggleClass("is-active");
		return false;
	});

	// =========================
	// MOBILE MENU ITEMS
	// =========================
	$(".menu-responsive .menu-item-has-children").click(function (e) {
		if (!$(this).hasClass("is-active")) {
			$(this).addClass("is-active");
			e.preventDefault();
		}
	});

	$(".mobile-nav .menu-item-has-children").append(
		'<span class="open-menu far fa-chevron-right"></span>',
	);

	// =========================
	// SUB MENU LEVEL HANDLING
	// =========================
	$(".open-menu").on("click", function () {
		var level1 = document.getElementsByClassName("level-1");

		if (level1.length > 0) {
			$(this).addClass("level-2-open");
			$(this).prev(".sub-menu").addClass("level-2");
			$(this).closest(".menu-item-has-children").addClass("level-2-hold");
		} else {
			$(this).addClass("level-1-open");
			$(this).prev(".sub-menu").addClass("level-1");
			$(this).closest(".menu-item-has-children").addClass("level-1-hold");
		}

		$(".navbar-toggler").addClass("hide-menu").removeClass("open-mobile-menu");
		$(".back-menu").addClass("show-back");
		$(this).siblings().addClass("is-active");
	});

	// =========================
	// NAV LINK
	// =========================
	$(".nav__link").click(function (e) {
		e.preventDefault();
		$(this).siblings().addClass("is-active");
	});

	// =========================
	// MOBILE NAV OPEN / CLOSE
	// =========================
	// $(".open-mobile-menu").on("click", function () {
	// 	const $this = $(this);

	// 	$this.toggleClass("active");
	// 	$("body").toggleClass("menu-is-open");

	// 	setTimeout(function () {
	// 		$(".menu-responsive-wrap-mobile").toggleClass("is-active");
	// 		$(".blackout").toggleClass("is-active");
	// 	}, 400);

	// 	// delayed remove active (FIXED)
	// 	if ($this.hasClass("active")) {
	// 		setTimeout(() => {
	// 			$this.removeClass("active");
	// 		}, 400);
	// 	}

	// 	return false;
	// });

	// =========================
	// MEGA MENU HOVER CLEANUP
	// =========================
	$(".chev_a").on("mouseenter", function () {
		$(".menu-responsive-wrap-search").removeClass("show-mega-search");
		$(".blackout-search").removeClass("is-active");
	});

	// =========================
	// CLOSE MENU BUTTON
	// =========================
	// $(".close-menu").on("click", function () {
	// 	$(".menu-responsive-wrap-mobile").removeClass("is-visible");
	// });

	// =========================
	// SCROLL NAV (JQUERY)
	// =========================
	$(window).scroll(function () {
		var sc = $(window).scrollTop();

		if (sc > 100) {
			$("#navbar").addClass("sticky-nav");
		} else {
			$("#navbar").removeClass("sticky-nav");
		}
	});

	// =========================
	// SEARCH
	// =========================
	$("#close-btn").click(function () {
		$("#search-overlay").fadeOut();
		$("#search-btn").show();
		$("body").removeClass("search_active");
	});

	$("#search-btn").click(function () {
		$("#search-overlay").fadeIn();
		$("body").addClass("search_active");
	});

	// =========================
	// HEADER SCROLL (VANILLA)
	// =========================
	const header = document.querySelector("header");

	window.addEventListener("scroll", () => {
		if (window.scrollY > 100) {
			header.classList.add("scrolled");
		} else {
			header.classList.remove("scrolled");
		}
	});
});

// =========================
// LAST SECTION DETECTION
// =========================
document.addEventListener("DOMContentLoaded", () => {
	const sections = document.querySelectorAll("#main-content section");

	if (sections.length) {
		const lastSection = sections[sections.length - 1];
		lastSection.classList.add("last-section");
	}
});
